export class AbstractChartParentComponent {
    public barChartLabels: Array<string> = [];
    public barChartData: Array<number> = [];
}
